import { useMutation } from '@tanstack/react-query';
import { apiPost } from '../../lib/api';

export function useCreatePilotMission() {
  return useMutation({
    mutationFn: (body) => apiPost('/pilot-missions', body),
  });
}
